// GLOBAL
import { _ } from 'lodash';
var nameService = (data) => _.camelCase(data.join("-"));
var snakeService = (data) => _.snakeCase(data).toUpperCase();
var kebabService = (data) => _.kebabCase(data.join("-"));
var nameStore = (name, store) => name + "/" + store;
const conf_api = ["GET", "POST", "PUT", "DELETE"];
const conf_arg = ["local", "prop", "state",];
const conf_act = ["get", "set", "update", "delete", "reset", "reload", "more"];
const conf_actions = { self: conf_act, array: conf_act, };

// SERVICE
const conf_service_data = [
    { service: "toolbar", conf: {type: Boolean, }, not: ["watch",] },
    { service: "email", conf: {type: Boolean, }, not: ["watch",] },
    { service: "emailar", conf: {type: Boolean, }, not: ["watch",] },
    { service: "postal", conf: {type: Boolean, }, not: ["watch",] },
    { service: "postalar", conf: {type: Boolean, }, not: ["watch",] },
    { service: "remind", conf: {type: Boolean, }, not: ["watch",] },
    { service: "manage", conf: {type: Boolean, }, not: ["watch",] },
    { service: "sms", conf: {type: Boolean, }, not: ["watch",] },
    { service: "guest", conf: {type: Boolean, }, not: ["watch",] },
    { service: "status", conf: {type: Boolean, }, not: ["watch",] },
    { service: "open", listorobj: true, not: ["data", "watch",], },
    { service: "close", listorobj: true, not: ["data", "watch",], },
    { service: "self", listorobj: true, not: ["data", "watch",], },
    { service: "click", listorobj: true, not: ["data", "watch",], },
    { service: "dblclick", listorobj: true, not: ["data", "watch",], },
    { service: "detail", listorobj: true, },
    { service: "remove-select", listorobj: true, not: ["data", "watch",], },
    { service: "add-select", listorobj: true, not: ["data", "watch",], },
    { service: "select", listorobj: true, },
    { service: "unselect", listorobj: true, },
    { service: "check", listorobj: true, },
    { service: "uncheck", listorobj: true, },
    { service: "add", listorobj: true, not: ["data", "watch", "prop"], },
    { service: "create", listorobj: true, not: ["data", "watch", "prop"], },
    { service: "edit", listorobj: true, },
    { service: "custom", listorobj: true, },
    { service: "change", listorobj: true, not: ["data", "watch",], },
    { service: "remove", listorobj: true, },
    { service: "reload", listorobj: true, not: ["data", "watch", "prop"], },
    { service: "ready", listorobj: true, not: ["data", "watch", "prop"], },
    { service: "action", listorobj: true, },
    { service: "cancel", listorobj: true, },
    { service: "share", conf: {type: [Array, Object, Number, String], not: []}, },
    { service: "index", conf: {type: [Array, Object, Number, String], not: []}, },
    { service: "options", listorobj: true, conf: {type: Object, default: {} }, },
    { service: "search", conf: {type: Object, default: {} }, },
    { service: "signature", conf: {type: Boolean, default: false}, },
    { service: "locked", conf: {type: Boolean, default: false}, },
    { service: "initials", conf: {type: Boolean, default: false}, },
    { service: "busy", conf: {type: Boolean, default: false}, not: ["prop",] },
    { service: "free", conf: {type: Boolean, default: true}, not: ["prop",] },
    { service: "loaded", conf: {type: Boolean, default: false}, not: ["prop",] },
    { service: "timer", conf: {type: Number, default: 300}, not: ["prop",] },
    { service: "counter", conf: {type: Number, default: 0} },
    { service: "submit-counter", conf: {type: Number, default: 0}, not: ["prop",] },
    { service: "reload-counter", conf: {type: Number, default: 0}, not: ["prop",] },
    { service: "offset", conf: {type: Number, default: 50}, not: ["prop",] },
    { service: "wait", conf: {type: [Array, Object, Number], default: undefined} },
    { service: "header", conf: { type: Boolean }, notemit: true, },
    { service: "hooter", conf: { type: Boolean }, notemit: true, },
    { service: "cancels", conf: { type: Object, default: {} }, not: ["prop", "emit",], },
    { service: "cancel-get", conf: { type: Object, }, not: ["prop", "emit",], },
    { service: "cancel-post", conf: { type: Object }, not: ["prop", "emit",], },
    { service: "sort", conf: { type: String } },
    { service: "form-config", conf: { type: Object, }, },
]

// STORE
const conf_store_data = {
    self: {},
    array: [],
    api: {},
    payload: {},
    stats: {},
};


// SHARED
const conf_auto = [
    { target: "self", data: conf_store_data, },
];

export {
    // GLOBAL
    nameService,
    snakeService,
    kebabService,
    nameStore,
    conf_api,
    conf_arg,
    conf_act,
    conf_actions,
    // SERVICE
    conf_service_data,
    // STORE
    conf_store_data,
    // SHARED
    conf_auto,
}
